<template>
<v-container fill-height fluid>
	<UserForm ref="userForm" 
		@user-created="refresh"
		@user-updated="refresh"
		@user-deleted="refresh"
	/>
	<v-row 
		align="center"
		justify="center">
		<v-data-table
			:headers="headers"
			:items="users"
			:loading="loading"
			:search="searchTerm"
			sort-by="name"
			class="elevation-1">
			<template v-slot:top>
				<v-container class="d-print-none">
					<div class="d-flex justify-space-around" >
						<h2>Users</h2>
						<v-spacer></v-spacer>
						<v-btn color="primary" dark class="mb-2 mr-2" small
							@click="$refs.userForm.createUser()">
							Create
						</v-btn>
						<v-btn color="primary" dark class="mb-2" small
							@click="refresh">
							Refresh
						</v-btn>
					</div>

					<v-row>
						<v-col cols="12" md="8" offset-md="2">
							<v-text-field
								label="Search"
								prepend-icon="mdi-magnify"
								v-model="searchTerm"
								autocomplete="off"/>
						</v-col>
					</v-row>
				</v-container>
				
			</template>

			<!-- <template v-slot:item._fullname="{ item }">
				{{ item.lastname }}, {{ item.firstname}} {{ item.middlename }}
			</template> -->

			<template v-slot:item.type="{ item }">
				{{ displayType(item) }}
			</template>

			<template v-slot:item.actions="{ item }">
				<v-icon
					small
					class="mr-2"
					@click="$refs.userForm.updateUser(item.id)">
					mdi-pencil
				</v-icon>
				<v-icon
					small
					@click="$refs.userForm.deleteUser(item.id)">
					mdi-delete
				</v-icon>
			</template>
			<template v-slot:no-data>
			<v-btn color="primary" @click="refresh">Refresh</v-btn>
			</template>
		</v-data-table>
	</v-row>
</v-container>
</template>


<script>
import Api from '../../services/api'
import { USER }from '../../services/constants'
import UserForm from './UserForm'

export default {
	name: 'users',
	components: { UserForm },
	data() {
		return {
			users: [],
			loading: false,
			headers: [
				{ text: 'ID', value: 'id' },
				{ text: 'Lastname', value: 'lastname' },
				{ text: 'Firstname', value: 'firstname' },
				{ text: 'Title', value: 'title' },
				{ text: 'Username', value: 'username', align: 'start' },
				{ text: 'Type', value: 'type' },
				{ text: 'Registered	', value: 'registerDateTime' },
				{ text: 'Actions', value: 'actions', sortable: false },
			],
			searchTerm: '',
		}
	},
	mounted() {
		this.refresh();
	},

	methods: {
		refresh() {
			this.loading = true;
			Api.user.getAll().then((response) => {
				this.users = response.data;
			})
			.catch(() => {
				this.users = [];
			})
			.finally(() => this.loading = false);
		},

		displayType(item) {
			let type = null;
			switch(item.type) {
				case USER.ADMIN: type = 'Admin'; break;
				case USER.TEACHER: type = 'Teacher'; break;
				case USER.REGISTRAR: type = 'Registrar'; break;
				case USER.TRAINING: type = 'Training Dept.'; break;
			}
			return type;
		}
	}
}
</script>